// BlogsPage.js

import React from "react";
import "../components/Styles/BlogsPage.css";

function BlogsPage() {

  const blogs = [

    {
      title:
        "Final Decree Not Mandatory When Preliminary Decree Provides Auction Clause: Supreme Court Ruling Explained",

      image:
        "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1200&auto=format&fit=crop",

      desc:
        "The Supreme Court clarified that when a preliminary decree already includes directions for auction and distribution, a separate final decree may not always be mandatory. This ruling simplifies partition disputes and reduces unnecessary litigation delays.",
    },

    {
      title:
        "RERA Registration Process in India: Complete Guide for Builders & Agents",

      image:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1200&auto=format&fit=crop",

      desc:
        "RERA registration is mandatory for real estate developers and agents before advertising or selling projects. Learn eligibility, required documents, registration fees, penalties, and how RERA protects homebuyers.",
    },

    {
      title:
        "FSSAI License for Cloud Kitchen: Documents, Fees & Online Process",

      image:
        "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?q=80&w=1200&auto=format&fit=crop",

      desc:
        "Running a cloud kitchen without FSSAI registration can lead to penalties. This article explains food license categories, registration process, government fees, and compliance rules for online food businesses.",
    },

    {
      title:
        "Court Marriage in India: Step-by-Step Legal Procedure Explained",

      image:
        "https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=1200&auto=format&fit=crop",

      desc:
        "Court marriage is a legal union conducted under the Special Marriage Act. Understand notice periods, required witnesses, documents, objections, and registration process for inter-caste and inter-faith marriages.",
    },

    {
      title:
        "Bigamy Laws in India: Is Second Marriage Legal Without Divorce?",

      image:
        "https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=1200&auto=format&fit=crop",

      desc:
        "Bigamy is prohibited under Indian law for most religions. Learn the legal consequences of second marriage without divorce, punishment under IPC, and rights available to affected spouses.",
    },

    {
      title:
        "Cybercrime Complaint Online: How to File a Cyber Fraud Case in India",

      image:
        "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=1200&auto=format&fit=crop",

      desc:
        "Cyber fraud and online scams are increasing rapidly. This guide explains how to report cybercrime online, preserve evidence, track complaints, and seek legal remedies under Indian cyber laws.",
    },

    {
      title:
        "Void and Voidable Marriage in India: Key Legal Differences",

      image:
        "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?q=80&w=1200&auto=format&fit=crop",

      desc:
        "A void marriage is invalid from the beginning, while a voidable marriage remains valid until annulled by court. Understand legal grounds, rights of spouses, and implications under family law.",
    },

    {
      title:
        "Possession Delay by Builder: Legal Remedies Available to Homebuyers",

      image:
        "https://images.unsplash.com/photo-1494526585095-c41746248156?q=80&w=1200&auto=format&fit=crop",

      desc:
        "Builders delaying possession beyond promised timelines can face RERA penalties and compensation claims. Learn how buyers can file complaints and seek refunds or interest legally.",
    },

  ];

  return (

    <div className="blogs-page">

      {/* HERO */}

      <section className="blogs-hero">

        <div className="blogs-overlay"></div>

        <div className="container hero-content">

          <h1>
            LegalAxis <span>Blogs</span>
          </h1>

          <p>
            Latest legal updates, business compliance guides,
            startup insights, property law news and expert legal articles.
          </p>

        </div>

      </section>

      {/* FREQUENT TOPICS */}

      <section className="topics-section">

        <div className="container">

          <div className="section-heading">

            <h2>Frequent Topics</h2>

          </div>

          <div className="topics-wrapper">

            <span>RERA Registration</span>
            <span>Section 355 BNS</span>
            <span>Section 355 in Hindi</span>
            <span>Inter-Cultural Marriage</span>
            <span>Payment Process Litigation</span>
            <span>Apply for FSSAI License</span>
            <span>FSSAI License for Cloud Kitchen</span>
            <span>Food License Apply Online</span>
            <span>Civil Marriage</span>
            <span>Invalid Marriage</span>
            <span>Marriage Null and Void</span>
            <span>Cybercrime</span>
            <span>Bigamy Laws India</span>
            <span>Second Marriage India</span>
            <span>Void and Voidable Marriage</span>
            <span>Possession Delay</span>
            <span>Court Marriage</span>
            <span>Bigamy India</span>
            <span>Married Man Court Marriage India</span>

          </div>

        </div>

      </section>

      {/* RECENT ARTICLES */}

      <section className="blogs-section">

        <div className="container">

          <div className="section-heading">

            <h2>Recent Articles</h2>

          </div>

          <div className="blogs-grid">

            {blogs.map((blog, index) => (

              <div className="blog-card" key={index}>

                <div className="blog-image">

                  <img src={blog.image} alt={blog.title} />

                </div>

                <div className="blog-content">

                  <h3>{blog.title}</h3>

                  <p>{blog.desc}</p>

                  <button>Read More</button>

                </div>

              </div>

            ))}

          </div>

        </div>

      </section>

    </div>

  );
}

export default BlogsPage;